var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.94043C7 2.38814 7.44771 1.94043 8 1.94043H16C16.5523 1.94043 17 2.38814 17 2.94043V5.74043H7V2.94043Z",
    stroke: "#757575",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80078 24.1406H18.2008V26.9406C18.2008 27.4929 17.7531 27.9406 17.2008 27.9406H6.80078C6.2485 27.9406 5.80078 27.4929 5.80078 26.9406V24.1406Z",
    stroke: "#757575",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5.74023,
    width: 22,
    height: 18.4,
    rx: 4,
    stroke: "#757575",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09946 13.1404C9.09946 13.527 8.78606 13.8404 8.39946 13.8404C8.01286 13.8404 7.69946 13.527 7.69946 13.1404C7.69946 12.7538 8.01286 12.4404 8.39946 12.4404C8.78606 12.4404 9.09946 12.7538 9.09946 13.1404Z",
    fill: "#757575",
    stroke: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3004 13.1404C16.3004 13.527 15.987 13.8404 15.6004 13.8404C15.2138 13.8404 14.9004 13.527 14.9004 13.1404C14.9004 12.7538 15.2138 12.4404 15.6004 12.4404C15.987 12.4404 16.3004 12.7538 16.3004 13.1404Z",
    fill: "#757575",
    stroke: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40039 16.7402C8.40039 16.7402 9.60039 18.5402 12.0004 18.5402C14.4004 18.5402 15.6004 16.7402 15.6004 16.7402",
    stroke: "#757575",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadIcon);
export default __webpack_public_path__ + "static/media/headIcon.6ef8db89e2c2cc2f132d73d8d526ccfa.svg";
export { ForwardRef as ReactComponent };